module.exports = __webpack_public_path__ + "static/media/hill_knowlton.497bf254.webp";